const generateData = (rows, query) => {
  const newData = rows.map((row, key) => ({
    num: query?.page * query?.pageSize + key + 1,
    date: row.cols[0],
    sumDiscount: row.cols[1],
    sumWithral: row.cols[2],
  }));

  return newData;
};

export default generateData;
